export default __webpack_public_path__ + "static/astra-zeneca2-094a66dfad33cc568bb066913959f4e7.png";